/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";

import { format } from "date-fns";

import OpenIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/KeyboardArrowUp";

import IIndicationHistory from "../../../../../types/IIndicationHistory";

const CompetitorIndication = ({
  indication,
  minimize,
}: {
  indication?: IIndicationHistory | null;
  minimize?: boolean;
}) => {
  const [open, setOpen] = useState(false);

  if (!indication) {
    return null;
  }
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        style={{
          backgroundColor: "#EDF2F9",
          boxShadow: "0px 0px 4px 0px #00000040",
          padding: "6px 5px",
          display: "flex",
          width: "fit-content",
          gap: 20,
          color: "#000000",
          fontSize: 14,
          fontWeight: 400,
          borderTopRightRadius: 5,
          borderTopLeftRadius: 5,
        }}
      >
        <div>{indication.marketer}</div>
        <div>
          {format(new Date(indication.dateLogged), "yyyy-MM-dd h:mm aa")}
        </div>
      </div>

      <div
        style={{
          backgroundColor: "white",
          border: "1px solid #d9d9d9",
          borderRadius: 5,
          padding: "0px 8px",
        }}
      >
        <div
          style={{
            display: "flex",
            cursor: !minimize ? undefined : "pointer",
            borderBottom: !minimize || open ? "1px solid #d9d9d9" : undefined,
          }}
          onClick={() => setOpen(!open)}
        >
          <div
            style={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: 60,
            }}
          >
            {indication.fobOrDlvd === "DLVD" && (
              <>
                <div>
                  <div style={{ display: "flex", gap: 4 }}>
                    <div
                      style={{ color: "black", fontWeight: 400 }}
                      className="priceFont"
                    >
                      {`$${Math.round(indication.deliveredPrice)}`}
                    </div>
                    <div className="priceDescFont">DLVD</div>
                  </div>
                  <div
                    style={{ fontSize: 12, color: "#474747", fontWeight: 400 }}
                  >
                    {indication.destination}
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{ fontSize: 16, fontWeight: 400 }}
                  >{`$${indication.freight}`}</div>
                  <div
                    style={{ color: "#474747", fontSize: 12, fontWeight: 400 }}
                  >
                    Freight
                  </div>
                </div>
              </>
            )}

            <div
              style={{
                display: "flex",
                gap: 4,
              }}
            >
              <div
                className="priceFont"
                style={{ color: "black", fontWeight: 400 }}
              >
                {indication.fobMaxPrice && indication.fobMinPrice
                  ? `$${Math.round(indication.fobMaxPrice)} - $${Math.round(
                      indication.fobMinPrice
                    )}`
                  : `$${Math.round(indication.fobPrice)}`}
              </div>
              <div className="priceDescFont">FOB</div>
            </div>
          </div>
          {minimize && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingLeft: 10,
              }}
            >
              {open ? (
                <CloseIcon style={{ fontSize: 30 }} />
              ) : (
                <OpenIcon style={{ fontSize: 30 }} />
              )}
            </div>
          )}
        </div>

        {(!minimize || open) && (
          <div
            style={{
              padding: "6px 0px",
              fontSize: 14,
              display: "flex",
              flexDirection: "column",
              gap: 5,
              marginBottom: 6,
              marginTop: 6,
            }}
          >
            <div style={{ fontWeight: 600, color: "#555" }}>
              Contact:{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {indication.contact}
              </span>
            </div>
            <div style={{ fontWeight: 600, color: "#555" }}>
              Company:{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {indication.account}
              </span>
            </div>

            <div style={{ fontWeight: 600, color: "#555" }}>
              Competitor(s):{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {indication.competitors.join(", ")}
              </span>
            </div>
            <div style={{ fontWeight: 600, color: "#555" }}>
              Ship Window:{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {`${indication.startDate} - ${indication.endDate}`}
              </span>
            </div>

            <div style={{ fontWeight: 600, color: "#555" }}>
              Mode:{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {indication.mode}
              </span>
            </div>

            <div style={{ fontWeight: 600, color: "#555" }}>
              Comments:{" "}
              <span
                style={{ color: "#333", fontSize: "0.9rem", fontWeight: 400 }}
              >
                {indication.comments ? indication.comments : "N/A"}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CompetitorIndication;
